import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { Languages, validLanguages } from '@remote-voice/utilities';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CancelButton from '@/components/atoms/CancelButton';

interface SubUserLanguageSelectProps {
  open: boolean;
  language: Languages;
  onClose: (selection?: Languages) => void;
  tCommon: (key: string) => string;
}

const SubUserLanguageSelect = ({
  open,
  language,
  onClose,
  tCommon,
}: SubUserLanguageSelectProps) => {
  const { t } = useTranslation('chat');
  const [selection, setSelection] = useState<Languages>(language);
  if (!open) return null;
  return (
    <Dialog open={open}>
      <DialogTitle>{t('menu.guestTranslationTitle')}</DialogTitle>
      <Typography textAlign="center" mb={1}>
        {t('menu.guestTranslationDescription')}
      </Typography>
      <DialogContent dividers>
        <RadioGroup
          value={selection ?? 'none'}
          onChange={(ev) => {
            const value = (ev.target as HTMLInputElement).value as any;
            setSelection(value !== 'none' ? value : undefined);
          }}
          sx={{ mb: 2 }}
        >
          {[...validLanguages].map((language) => (
            <FormControlLabel
              value={language}
              key={language}
              control={<Radio />}
              label={tCommon(`languages.${language}` as any)}
            />
          ))}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          gap={1}
          width={1}
        >
          <CancelButton onClick={() => onClose()} />
          <Button
            key="ok"
            onClick={() => {
              onClose(selection);
            }}
          >
            {tCommon('command.ok')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default SubUserLanguageSelect;
